import { render, staticRenderFns } from "./CharacterWord.vue?vue&type=template&id=61de81fb&scoped=true"
import script from "./CharacterWord.vue?vue&type=script&lang=js"
export * from "./CharacterWord.vue?vue&type=script&lang=js"
import style0 from "./CharacterWord.vue?vue&type=style&index=0&id=61de81fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de81fb",
  null
  
)

export default component.exports